import { SentryTestScreen } from "@/screens";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sentry-test")({
  component: SentryTestScreen,
  loader: async () => {
    return {
      crumb: "Sentry Test",
    };
  },
});
